export const createAction = (action) => {
  const conf = {
    ACTION: action,
    REQUEST: `${action}_REQUEST`,
    SUCCESS: `${action}_SUCCESS`,
    ERROR: `${action}_ERROR`,
  };
  conf.requestAction = (payload) => ({
    type: conf.REQUEST,
    payload: payload === undefined ? {} : payload,
  });
  conf.successAction = (payload) => ({
    type: conf.SUCCESS,
    payload: payload ?? {},
  });
  conf.errorAction = (error) => ({
    type: conf.ERROR,
    payload: { error },
  });
  return conf;
};

export const SITES_FETCH = createAction('SITES_FETCH');
export const SITE_CREATE = createAction('SITE_CREATE');
export const SITE_UPDATE = createAction('SITE_UPDATE');

export const JOBS_FETCH = createAction('JOBS_FETCH');
export const JOB_FETCH_BY_ID = createAction('JOB_FETCH_BY_ID');
export const JOB_CREATE = createAction('JOB_CREATE');
export const JOB_UPDATE = createAction('JOB_UPDATE');
export const JOB_SELECT = createAction('JOB_SELECT');

export const TREES_FETCH = createAction('TREES_FETCH');
export const TREE_FETCH_BY_ID = createAction('TREE_FETCH_BY_ID');
export const TREE_CREATE = createAction('TREE_CREATE');
export const TREE_UPDATE = createAction('TREE_UPDATE');
export const TREES_ASSIGN_JOB = createAction('TREES_ASSIGN_JOB');

export const GROUPS_FETCH = createAction('GROUPS_FETCH');
export const GROUP_CREATE = createAction('GROUP_CREATE');
export const GROUP_ADD_TREES = createAction('GROUP_ADD_TREES');
export const GROUP_REMOVE_TREES = createAction('GROUP_REMOVE_TREES');
export const GROUP_DELETE = createAction('GROUP_DELETE');

export const LOOKUP_ENUMS_FETCH = createAction('LOOKUP_ENUMS_FETCH');
export const LOOKUP_SPECIES_FETCH = createAction('LOOKUP_SPECIES_FETCH');

export const MAP_SELECT_TREE = createAction('MAP_SELECT_TREE');
export const MAP_TOGGLE_TREE_SELECTION = createAction('MAP_TOGGLE_TREE_SELECTION');
export const MAP_CLEAR_SELECTION = createAction('MAP_CLEAR_SELECTION');
export const MAP_SET_SIDEBAR_TAB = createAction('MAP_SET_SIDEBAR_TAB');
export const MAP_TOGGLE_SIDEBAR = createAction('MAP_TOGGLE_SIDEBAR');
export const MAP_SET_SIDEBAR = createAction('MAP_SET_SIDEBAR');
export const MAP_SET_PLACE_MODE = createAction('MAP_SET_PLACE_MODE');
export const MAP_SET_SITE_PICK_MODE = createAction('MAP_SET_SITE_PICK_MODE');
export const MAP_SET_SELECTION_MODE = createAction('MAP_SET_SELECTION_MODE');
export const MAP_SET_LAST_TREE_DRAFT = createAction('MAP_SET_LAST_TREE_DRAFT');
